import React, { useEffect, useRef } from 'react';
import './historyCompany.scss';

const HistoryCompany = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="history-company">
      <div className="history-company__mainContainer">
        <div className="history-company__section">
          <h2 className="content__title-backgroundWhite">NUESTRA HISTORIA</h2>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <h3 className="content__subtitle-backgroundWhite">
            ¿Por qué surge WONDERALY?
          </h3>
          <p className="content__text-title-backgroundWhite">
            WONDERALY INNOVATIONS nació de la visión de Alicia Rodríguez Magro,
            licenciada en Psicología Aplicada y en Publicidad, investigadora de
            neuropsicología aplicada a la producción en la University of London,
            con años de experiencia en Italia, Irlanda y Lisboa. Su propósito:
            integrar la ciencia del comportamiento humano en el mundo de las
            artes y la producción audiovisual.
          </p>
        </div>
        <div className="history-company__section">
          <p className="content__text-paragrah-backgroundWhite">
            Detectamos una brecha significativa en la industria cinematográfica:
            los proyectos audiovisuales se gestionaban únicamente desde la
            experiencia técnica y creativa, sin aprovechar el conocimiento
            neuropsicológico que puede transformar radicalmente la conexión
            emocional entre la obra y el espectador.
          </p>
          <p className="content__text-paragrah-backgroundWhite">
            Así surgió WONDERALY, como respuesta pionera a esa necesidad. Al
            igual que el psicólogo en el deporte revolucionó el rendimiento de
            los atletas, nuestra misión es hacer lo mismo en la producción
            audiovisual: aportar un enfoque neuro-psicológico-científico que
            optimice cada fase del proceso creativo.
          </p>
          <p className="content__text-paragrah-backgroundWhite">
            Hoy trabajamos con productoras y equipos creativos, aplicando
            neuropsicología, IA y Business Intelligence para crear experiencias
            cinematográficas más memorables, emotivas y efectivas. Nuestra
            primera aplicación real, la película
            <strong style={{ color: '#D4A843' }}> "Somos Reyes"</strong>, es el
            primer ejemplo de lo que el Neurocinema Project puede lograr.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HistoryCompany;
